import { Link } from 'react-router-dom'
import { Zap, BatteryCharging, TrendingDown, Sparkles } from 'lucide-react'

// The EnergyOS-specific landing page — reached from the root LandingPage's card. Its own top
// bar (Sign in / Sign up) is intentionally separate from Rabbit Console's /login page chrome,
// matching the user's brief of a second, dedicated landing page for EnergyOS itself.
export function EnergyOSLanding() {
  return (
    <div className="min-h-screen bg-white">
      <header className="h-14 border-b border-paper-border flex items-center justify-between px-6">
        <Link to="/energy-os" className="flex items-center gap-2">
          <div className="w-7 h-7 rounded-lg bg-accent flex items-center justify-center">
            <Zap size={14} className="text-white" />
          </div>
          <span className="text-ink font-semibold text-[15px] tracking-tight">EnergyOS</span>
        </Link>
        <div className="flex items-center gap-2">
          <Link to="/login" className="btn-secondary text-sm">Sign in</Link>
          <Link to="/energy-os/signup" className="btn-primary text-sm">Sign up</Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-4 py-20 text-center">
        <div className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-accent-soft border border-accent/20 text-accent text-xs font-medium mb-6">
          <Sparkles size={12} /> AI-powered energy automation
        </div>
        <h1 className="text-3xl font-semibold text-ink mb-4 tracking-tight">
          Your home's energy, on autopilot
        </h1>
        <p className="text-[15px] text-ink-dim leading-relaxed max-w-xl mx-auto mb-10">
          EnergyOS connects to your solar, battery and smart devices, learns your habits,
          and automatically decides when to charge, discharge or shift usage — so you save
          money without lifting a finger.
        </p>

        <div className="flex items-center justify-center gap-3 mb-16">
          <Link to="/energy-os/signup" className="btn-primary px-5 py-2.5">Get started</Link>
          <Link to="/login" className="btn-secondary px-5 py-2.5">I already have an account</Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-left">
          <div className="card p-5">
            <BatteryCharging size={18} className="text-accent mb-2" />
            <p className="text-sm font-semibold text-ink mb-1">Smart charging</p>
            <p className="text-xs text-ink-dim leading-relaxed">
              Batteries and EVs charge when power is cheapest or greenest, automatically.
            </p>
          </div>
          <div className="card p-5">
            <TrendingDown size={18} className="text-accent mb-2" />
            <p className="text-sm font-semibold text-ink mb-1">Lower bills</p>
            <p className="text-xs text-ink-dim leading-relaxed">
              Real-time price signals drive every decision, avoiding expensive peak hours.
            </p>
          </div>
          <div className="card p-5">
            <Sparkles size={18} className="text-accent mb-2" />
            <p className="text-sm font-semibold text-ink mb-1">Learns your home</p>
            <p className="text-xs text-ink-dim leading-relaxed">
              Occupancy and seasonal patterns continuously refine every future plan.
            </p>
          </div>
        </div>
      </main>
    </div>
  )
}
